// frontend/src/api/dashboard.js
// Funciones API para obtener los datos del Dashboard General.

import { request } from './api';

/**
 * @function getDashboardSummary
 * @description Obtiene el resumen de métricas consolidadas del backend.
 * @param {string} token - Token JWT para autorización.
 * @param {object} [filters={}] - Objeto con filtros opcionales (ej: { startDate: 'YYYY-MM-DD', endDate: 'YYYY-MM-DD' }).
 * @returns {Promise<object>} - Una promesa que resuelve con el objeto de resumen del dashboard.
 */
export async function getDashboardSummary(token, filters = {}) {
  const queryParams = new URLSearchParams(filters).toString();
  const endpoint = `/api/dashboard/summary${queryParams ? `?${queryParams}` : ''}`;
  return request(endpoint, 'GET', null, token);
}

/**
 * @function getMonthlyRevenueData
 * @description Obtiene datos de ingresos mensuales desglosados por fase del backend.
 * @param {string} token - Token JWT para autorización.
 * @param {object} [filters={}] - Objeto con filtros opcionales (ej: { period: '12m' }).
 * @returns {Promise<Array<object>>} - Una promesa que resuelve con un array de objetos de datos mensuales.
 */
export async function getMonthlyRevenueData(token, filters = {}) { // Asegurarse de que esta función se exporte
  const queryParams = new URLSearchParams(filters).toString();
  const endpoint = `/api/dashboard/monthly-revenue${queryParams ? `?${queryParams}` : ''}`;
  return request(endpoint, 'GET', null, token);
}
